export const data = [
  {
    id: 1,
    place: "Priority Pulse 1",
    coordinatex: 25.317644,
    coordinatey: 82.973915,
  },
  {
    id: 2,
    place: "Priority Pulse 2",
    coordinatex: 26.317644,
    coordinatey: 80.973915,
  },
  {
    id: 3,
    place: "Priority Pulse 3",
    coordinatex: 28.317644,
    coordinatey: 77.973915,
  },
  {
    id: 4,
    place: "Priority Pulse 4",
    coordinatex: 29.317644,
    coordinatey: 81.973915,
  },
  {
    id: 5,
    place: "Priority Pulse 5",
    coordinatex: 25.317644,
    coordinatey: 79.973915,
  },
];
